export const PRICING_PAGE_ROUTE = Object.freeze({
  PRICING: "/skiply-portal/Pricing",
});

export const PRICING_TABS = Object.freeze({
  PRICING: "pricing",
  PENDING: "pending",
});

export const FIELD_KEYS = Object.freeze({
  mdrPercent: "mdrPercent",
  mdrFlat: "mdrFlat",
});

export const RATE_COLUMN_KEYS = Object.freeze([
  FIELD_KEYS.mdrPercent,
  FIELD_KEYS.mdrFlat,
]);

export const PRICING_COLUMNS = Object.freeze([
  { key: "region", label: "Region" },
  { key: "product", label: "Product" },
  { key: "cardType", label: "Card type" },
  { key: "scheme", label: "Scheme" },
  { key: "txn", label: "TXN" },
  { key: "mdrPercent", label: "MDR %" },
  { key: "mdrFlat", label: "MDR FLAT (AED)" },
]);

export const NODE_TYPE_COLUMN_MAP = Object.freeze({
  DEFAULT: "region",
  REGION: "region",
  PRODUCT: "product",
  CARD_TYPE: "cardType",
  SCHEME: "scheme",
  TRANSACTION_TYPE: "txn",
});